export const GAME_WIDTH = 240;
export const GAME_HEIGHT = 160;

export const BLOCK_RENDER_SIDE_LEN = 20;

export const GRID_BLOCK_SIDE_LEN = 5;
export const GRID_BLOCK_CENTER = Math.floor(GRID_BLOCK_SIDE_LEN / 2);
export const GRID_RENDER_SIDE_LEN = GRID_BLOCK_SIDE_LEN * BLOCK_RENDER_SIDE_LEN;
export const GRID_RENDER_OFFSET_X = BLOCK_RENDER_SIDE_LEN * 2;
export const GRID_RENDER_OFFSET_Y = BLOCK_RENDER_SIDE_LEN * 1.5;

export const INVENTORY_ITEM_H = 3 * GRID_BLOCK_SIDE_LEN + 4;
export const INVENTORY_ITEM_STEP_Y = INVENTORY_ITEM_H + 2;
export const INVENTORY_OFFSET_X =
  GRID_RENDER_OFFSET_X + GRID_RENDER_SIDE_LEN + BLOCK_RENDER_SIDE_LEN;
export const INVENTORY_OFFSET_Y =
  GRID_RENDER_OFFSET_Y - Math.floor(INVENTORY_ITEM_STEP_Y / 2);

export const COLORS = {
  // shared
  BOARD: "#001948ff",
  BORDER: "#889EB3",
  // grid
  GRID_BACKGROUND: "#124D7F",
  GRID_CURSOR: "lime",
  GRID_CURSOR_LETTER: "#0006",
  LINE_SHADOW: "#00000033",
  // line
  PROCESSING_LETTER: "WHITE",
  CORRECT_LETTER: "lime",
  INCORRECT_LETTER: "red",
  INVALID_LETTER: "orange",
  // inventory
  INVENTORY_CURSOR_LIGHT: "#64ff49ff",
  INVENTORY_CURSOR_MID: "#11b41cff",
  INVENTORY_CURSOR_DARK: "#04843eff",
};
